import type { Remote } from 'comlink'
import type { IPlaybackSchedulerWorker } from '@/services/PlaybackScheduler'
import { wrap } from 'comlink'
import PlaybackSchedulerWorker from '@/workers/playback-scheduler?worker'

export type TPlaybackScheduler = Remote<IPlaybackSchedulerWorker>

/**
 * Comlink bridge to the playback scheduler worker (frame loop timing, buffer hand-off).
 * Main thread owns full {@link IQueueFrame} data and sends a slim `playbackPlan` (ids + durations);
 * the worker runs clocks and notifies listeners with the same slim rows for main-side facet resolution.
 */
const WORKERS_SERVICE_GLOBAL_KEY = '__lucimarkSharedWorkersService'

/** One playback worker per tab — survives {@link VBuffer} unmount/remount and Vite HMR module re-eval. */
export function getSharedWorkersService(): WorkersService {
  const g = globalThis as Record<string, unknown>
  if (g[WORKERS_SERVICE_GLOBAL_KEY] == null) {
    g[WORKERS_SERVICE_GLOBAL_KEY] = new WorkersService()
  }
  return g[WORKERS_SERVICE_GLOBAL_KEY] as WorkersService
}

export default class WorkersService {
  readonly playbackScheduler: TPlaybackScheduler
  constructor() {
    this.playbackScheduler = wrap<TPlaybackScheduler>(new PlaybackSchedulerWorker())
  }
}
